import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// Styles
import 'react-notifications-component/dist/theme.css';
import 'assets/styles/bootstrap.css';
import 'assets/styles/sumadi.css';
import 'assets/styles/dev_updates.css';
import 'react-h5-audio-player/lib/styles.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
// loading translations
import './i18n/index';
// React Imports
import { createRoot } from 'react-dom/client';
// Emotion
import { ThemeProvider } from '@emotion/react';
// React Notifications
import { ReactNotifications } from 'react-notifications-component';
// Custom Imports
import { theme } from 'themes/default';
import AppRouter from 'router/router';
import ExamsApolloClient from 'components/containers/apollo-exams-client/apollo-exams-client';
import { SideTabContextProvider } from 'context/sidetab-context';
const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container);
root.render(_jsxs(ThemeProvider, Object.assign({ theme: theme }, { children: [_jsx(ReactNotifications, {}, void 0), _jsx(ExamsApolloClient, { children: _jsx(SideTabContextProvider, { children: _jsx(AppRouter, {}, void 0) }, void 0) }, void 0)] }), void 0));
